import * as bootstrap from 'bootstrap';
export enum MessageSectionType {
    Row,
    Text
}

export enum DisplayStyle {
    Primary = "primary",
    Secondary = "secondary",
    Success = "success",
    Warning = "warning",
    Danger = "danger",
    Info = "info",
    Light = "light",
    Dark = "dark",
    None = ""
}

export type ToastDisplayStyles = DisplayStyle.Info | DisplayStyle.Success | DisplayStyle.Warning | DisplayStyle.Danger;
    
export enum UserPinType {
    Signoff = "Signoff",
    Prescription = "Prescription"
};

export enum TextDisplayStyle {
    Muted = "muted",
    NoClass = "--NoDisplayClass--"    // Do not generate a display class.  Rely on the default CSS
}

// Can be a union with DisplayStyle so make sure the value is outside the range of DisplayStyle or anything we would have a union of
export enum ButtonDisplayStyle {
    Link = "link",
    OutlinePrimary = "outline-primary",
    OutlineSecondary = "outline-secondary",
    OutlineSuccess = "outline-success",
    OutlineWarning = "outline-warning",
    OutlineDanger = "outline-danger",
    OutlineInfo = "outline-info",
    OutlineLight = "outline-light",
    OutlineDark = "outline-dark",

    TextPrimary = "text-primary",
    TextSuccess = "text-success",
    TextWarning = "text-warning",
    TextDanger = "text-danger"
}

export enum ExtraButtonDisplayStyle {
    OutlineGrey = "outline-grey"
}

export enum ButtonDisplaySize {
    XS = "xs",
    Smaller="smaller",
    Small ="small",
    Default = "default-size",
    Large = "large"
}

export enum AlignmentType {
    Left = "left",
    Right = "right",
    Center = "center"
}

// Indicates what type of row we're working on
export enum TableRowType {
    Header,
    Body,
    Footer
}
// Indicates what where row is highlight when selected
export enum TableRowHighlight {
    NoHighLight,
    onSingleClick,  // Use this when you have a cell class that won't change background color
    onSingleClickBorder, // Use this when you have a cell class that may change background color
    onDoubleClick, // Use this when you have a cell class that won't change background color
    onDoubleClickBorder  // Use this when you have a cell class that may change background color
}

export enum DropDownButtonIconType {
    Bolt,
    Hamburger,
    Gear,
    Spinner,
    DropDownOnly,
    Other
}


export enum HtmlChangeEventType 
{ 
    input = "input", 
    change = "change", 
    paste = "paste",
    keypress = "keypress"
}

export enum ModalSize
{
    Small,
    Medium,
    Large,
    XL,
    FullScreen
}

export enum DateDisplayFormat
{
    PrettyDate = "MMM dd, yyyy",
    NumericDate = "mm/dd/yyyy",
    NumericDashDate = "mm-dd-yyyy",
    ISO8601 = "ISO 8601" // YYYY-MM-DDThh:mm:ss
}

export enum TextInputType
{
    text="text",
    email ="email",
    telephone ="tel",
    password= "password"
}

// Consolidated icon definitions
export enum IconTypes
{
    Save="Save",
    Post="Post",
    Complete="Complete",
    Add="Add",
    Delete="Delete",
    Remove="Remove",
    Export="Export",
    Import="Import",
    Close="Close",
    Report="Report",
    Edit="Edit",
    Ignore="Ignore",
    Warning="Warning",
    Reverse="Reverse",
    Hold="Hold",
    Calendar="Calendar",
    Communication="Communication",
    Receipt="Receipt",
    Invoice="Invoice",
    InvoiceDollar="InvoiceDollar",
    Statement="Statement",
    Send="Send",
    Excel="Excel",
    Print="Print",
    Setting="Setting",
    Customize="Customize",
    Tools="Tools",
    Search="Search",
    Location="Location",
    Next="Next",
    Forward="Forward",
    Last="Last",
    Previous="Previous",
    Backward="Backward",
    First="First",
    Lock="Lock",
    Unlock="Unlock",
    Reassign="Reassign",
    Attach="Attach",
    New="New",
    Blank="Blank",
    Notification="Notification",
    User="User",
    Users="Users",
    Filter="Filter",
    Comment="Comment",
    Comments="Comments",
    TurnRight="TurnRight",
    TurnLeft="TurnLeft",
    Star="Star",
    Action="Action",
    Tag="Tag",
    Phone="Phone",
    Email="Email",
    ChveronDown = "ChveronDown",
    ChveronUp = "ChveronUp",
    ChveronLeft = "ChveronLeft",
    ChveronRight = "ChveronRight",
    Doctor = "Doctor",
    MedicalHouse = "MedicalHouse",
    Trashcan = "Trashcan",
    Unknown = "Unknown",
    Ready = "Ready",
    Refresh = "Refresh",
    RxBase = "RxBase",
    RxLevel1 = "RxLevel1",
    RxLevel2 = "RxLevel2",
    RxLevel3 = "RxLevel3",
    RxLevel9 = "RxLevel9",
    RxLevel10 = "RxLevel10",
    AngleDoubleLeft = "AngleDoubleLeft",
    AngleDoubleRight = "AngleDoubleRight",
    Ellipsis = "Ellipsis",
    InsuranceCard = "InsuranceCard",
    PrimaryInsurance = "PrimaryInsurance",
    SecondaryInsurance = "SecondaryInsurance",
    TertiaryInsurance = "TertiaryInsurance",
    Error = "Error",
    Clock = "Clock",
    VerticalEllipsis = "VerticalEllipsis",
    SortNumeric = "SortNumeric",
    CheckMark = "CheckMark",
    XMark = "XMark",
    PopOpen = "PopOpen",
    Clipboard = "Clipboard",
    CreditCard="CreditCard",
    DeferPayment="DeferPayment",
    Medications="Medications",
    Umbrella="Umbrella",
    Shield="Shield",
    Inbox="Inbox",
    Bill="Bill",
    Order="Order",
    CircleXMark = "CircleXMark",
    Information = "Information",
    MMLConnected = "MMLConnected",
    MMLInvite = "MMLInvite",
    MMLOptOut = "MMLOptOut",
    SpinnerDots = "SpinnerDots",
    CircleHollow = "CircleHollow",
    CircleExclamation = "CircleExclamation",
    CircleCheck = "CircleCheck",
    CircleInfo = "CircleInfo",
    CircleQuestion = "CircleQuestion",
    View = "View",
    Download = "Download",
    DragDrop = "DragDrop",
    Waiting = "Waiting",
    Processing = "Processing",
    Deleted = "Deleted",
    ArrowLeft= "ArrowLeft",
    ArrowRight= "ArrowRight",
    ArrowUp= "ArrowUp",
    ArrowDown= "ArrowDown",
    Flask="Flask",
    Sort="Sort",
    SortUp="SortUp",
    SortDown="SortDown",
    Mobile = "Mobile",
    MobileScreen = "MobileScreen",
    RegularClipboard = "RegularClipboard",
    CsvFile = "CsvFile",
    ToggleOn = "ToggleOn",
    ToggleOff = "ToggleOff",
    Message = "Message",
    Briefcase = "Briefcase"
}

export enum HoverCursorTypes
{
    // General
    Auto="auto",
    Default="default",
    None="none",

    // Links & Status
    ContextMenu = "context-menu",
    Help = "help",
    Pointer = "pointer",
    Progress = "progress",
    Wait = "wait"
}

export enum LayoutOrientation
{
    Vert = "vertical",
    Horz = "horizontal"
}

// What do we use as the parent modal
export enum ModalParent
{
    appFull,        //  The whole application window
    appMain,        //  The 'main' (right) application window
    launchWindow    //  The window that asked for hte modal
}

export enum KeyboardEventType 
{ 
    backspace = "backspace", 
    delete = "delete"
}

export enum PaginationButtonSizeStyle
{
    Small = "btn-group-sm",
    Medium = "",    //Bootstrap default, no style needed
    Large = "btn-group-lg"
}

export enum AlignmentTypeStyle {
    Left = "d-flex justify-content-start",
    Center = "d-flex justify-content-center",
    Right = "d-flex justify-content-end"
}

export enum NonModalDisplayMode {
    TopCentered     // Near the top of the window & aligned to the middle of the viewport7
}

export enum ToastsPlacement {
    TopLeft = "top-0 start-0",
    TopCenter = "top-0 start-50 translate-middle-x",
    TopRight = "top-0 end-0",
    // MiddleLeft = "top-50 start-0 translate-middle-y",
    // MiddleCenter = "top-50 start-50 translate-middle",
    // MiddleRight = "top-50 end-0 translate-middle-y",
    BottomLeft = "bottom-0 start-0",
    BottomCenter = "bottom-0 start-50 translate-middle-x",
    BottomRight = "bottom-0 end-0"
}

export enum IconAnimation
{
    spin = "fa-spin",
    pulse = "fa-pulse"
}

export enum TitleType
{
    PageTitle,          // EH CSS: HeadingSm
    SectionTitle,       // EH CSS: BodyMd
    SectionSubTitle,    // EH CSS: LabelSmProminent
    BoldLabel,          // EH CSS: LabelMd
    PageBreadcrumb,     // EH CSS: BodyMdProminent
    SmallLabel,         // EH CSS: LabelSm

    // EverHealth CSS names
    HeadingSm,
    LabelSmProminent,
    BodyMd,
    BodyLg,
    LabelMd,
    LabelSm,
    BodyMdProminent
}

export enum CssFramework
{
    Bootstrap,
    EverHealth
}

export enum IconFamily
{
    FontAwesome = "font-awesome",
    Material = "material"    
}

export enum TitleDisplayStyle
{
    Block = "block",
    Inline = "inline"
}